import "./styles.scss";
import {FC} from "react";
import {useTranslation} from "react-i18next";

interface CoinsProps {
    val: string | number;
    type: 'FPP' | 'GOS';
}

const Coins:FC<CoinsProps> = ({ val, type }) => {
    const { t } = useTranslation();
    return (
    <div className="coinBalance">
      <span>{parseFloat(val as string).toFixed()} {type === 'GOS' && t('gosCoin')}</span>
      <img src={`/static/images/${type === 'FPP' ? 'coin' : 'gosCoin'}.png `} alt={type} />
    </div>
  );
};
export default Coins;
